// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { PostCategoriesFragmentDoc } from '../../graphql/api/cms/blog/fragments/postCategories.generated';
import { BlogMenuFragmentDoc } from '../../components/cms/component/blog/BlogMenu.generated';
import { BlogPostPreviewFragmentDoc } from '../../components/cms/component/blog/BlogPostPreview.generated';
import { ImageLargeFragmentDoc } from '../../components/cms/imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../components/cms/imageSize.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const PostsByCategoryDocument = `
    query postsByCategory($slug: String!, $page: Int!, $limit: Int!, $locale: Locale!) {
  ...postCategories
  collection: postCategoryBySlug(slug: $slug, locale: $locale) {
    id
    name
    posts(page: $page, limit: $limit, locale: $locale) {
      ...blogPostPreview
    }
    postAggregation(locale: $locale) {
      count
    }
  }
}
    ${PostCategoriesFragmentDoc}
${BlogMenuFragmentDoc}
${BlogPostPreviewFragmentDoc}
${ImageLargeFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}`;

export function usePostsByCategoryQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.PostsByCategoryQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.PostsByCategoryQuery, SchemaTypes.PostsByCategoryQueryVariables | undefined>({ query: PostsByCategoryDocument, variables: undefined, ...options });
};